import React, { FC } from 'react';

interface IProps {
  color?: string;
}

export const ArrowDownSwitchStoreIcon: FC<IProps> = ({ color = '#ffffff' }: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="6"
      viewBox="0 0 11 6"
      fill="none"
      style={{ color: color }}
    >
      <path
        d="M5.32031 5.67505C5.16342 5.67503 5.01149 5.61665 4.9043 5.51099L0.0224605 0.693604C0.00715784 0.678505 -0.00120874 0.657312 -4.40529e-07 0.635987C0.00126413 0.614701 0.0114293 0.594571 0.0283199 0.5813L0.752929 0.01587C0.775358 -0.00144634 0.805238 -0.00444612 0.830078 0.00610437L0.853515 0.0217294L5.32031 4.42896L9.78711 0.0217286C9.80747 0.0018316 9.83725 -0.00466864 9.86328 0.0031739L9.88769 0.0158692L10.6123 0.581299C10.6291 0.594568 10.6394 0.614742 10.6406 0.635986C10.6418 0.657281 10.6344 0.678511 10.6191 0.693604L5.73633 5.51099C5.62913 5.61664 5.4772 5.67503 5.32031 5.67505Z"
        fill="currentColor"
      />
    </svg>
  );
};
